import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '@cx-web/components/primitives/icon';
import Title, { Header } from '@cx-web/components/primitives/title';

import { useSwipe } from '../../hooks/useSwipe';
import FeaturedMenu from '../FeaturedMenu';
import SportsList from '../SportsList';

import styles from './AllSportsMenu.module.css';

interface AllSportsMenuProps {
  allSportsOpen: boolean;
  setAllSportsOpen: (value: boolean) => void;
}

export const AllSportsMenu = ({ allSportsOpen, setAllSportsOpen }: AllSportsMenuProps) => {
  const { t } = useTranslation(['label']);

  const openCloseSportsMenu = (): void => {
    setAllSportsOpen(!allSportsOpen);
  };

  const { handlers, isFullHeight } = useSwipe(openCloseSportsMenu);

  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <section
      aria-label="All Sports Menu"
      className={`${styles.allSportsMenu} ${allSportsOpen ? styles.open : ''} ${isFullHeight ? styles.fullHeight : ''}`}
      data-testid="all-sports-menu"
      ref={wrapperRef}
    >
      <div className={styles.content}>
        <header className={styles.header} {...handlers}>
          <Title tag={Header.SPAN} testId="all-sports-heading" title={t('CX_SPORTS_ODDS')} />
          <button aria-label="Close menu" onClick={openCloseSportsMenu}>
            <Icon icon="Close" />
          </button>
        </header>
        <FeaturedMenu />
        <SportsList />
      </div>
    </section>
  );
};
